




















import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'

export enum CrumbType {
    DEFAULT = 'crumb',
    LEADS = 'leads-crumb',
    LEAD = 'lead-crumb',
    ORDER = 'order-crumb',
    ORDERS = 'orders-crumb',
    REPORTS = 'report-crumb',
    PIPELINES_ENABLED = 'pipelines-enabled-crumb',
}

@Component
export default class Bread extends Vue {

    routes: Route[] = []
    hiddenRoutes = [
        'dashboard',
        'tasks_all',
        'tasks_detail_emma_appraisal',
        'tasks_detail_future_address',
        'tasks_detail_financial',
        'tasks_detail_files',
        'orders_all',
        'orders_detail_future_address',
        'orders_detail_financial',
        'orders_detail_files',
        'typeform',
        'reports',
        'company_settings_virtual_colleague',
    ]

    @Watch('route', { immediate: true })
    watchRoute(to): void {
        this.routes = to.matched.filter(route => !this.hiddenRoutes.includes(route.name))
    }

    getCrumbType(route: Route): string {
        switch (route.name) {
            case 'tasks':
                return CrumbType.LEADS
            case 'tasks_detail':
                return CrumbType.LEAD
            case 'orders':
                return CrumbType.ORDERS
            case 'orders_detail':
                return CrumbType.ORDER
            case 'report':
                return CrumbType.REPORTS
            default:
                return CrumbType.DEFAULT
        }
    }

    get dashboardRoute(): Route {
        return this.$router.resolve({ name: 'dashboard' }).route
    }

    get route(): Route {
        return this.$route
    }
}

